import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { postProduct } from "../../../services/Rest.jsx";
import Button from "../button/Button";
import DecimalInput from "../input/DecimalInput.jsx";
import TextInput from "../input/TextInput";

const FormLogin = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const initialState = {
    cod: "",
    nc: "",
    name: "",
    capacity: "",
    percentage: "",
    codigo_impositivo: "",
    clave_product: "",
    excise_product_code: "",
  };

  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const decimalRegex = /^\d*(?:.\d*)?$/;

    const hasEmpty = Object
      .values(formData)
      .some(val => val.trim() === "");

    if (hasEmpty) {
      alert("Por favor, rellene todos los campos.");
      return;
    }
    if (decimalRegex.test(e.target.capacity) && decimalRegex.test(e.target.percentage)) {
      setError("Los campos Capacidad y Porcentaje deben ser decimales.");
      return;
    }
    try {
      await postProduct({
        cod: formData.cod,
        nc: formData.nc,
        name: formData.name,
        capacity: formData.capacity,
        percentage: formData.percentage,
        codigo_impositivo: formData.codigo_impositivo,
        clave_product: formData.clave_product,
      });
      navigate("/products");
    } catch (e) {
      console.log(e);
      setError(e.response.message);
    }
  };

  const cancelOnClick = (e) => {
    e.preventDefault();
    navigate("/products");
  };

  return (
    <form id="login-form" className="space-y-4" onSubmit={handleSubmit}>
      {error && <p className="text-red-500 text-sm">{error}</p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 space-y-4">
        <TextInput
          id="cod"
          type="text"
          text="Código de Producto"
          placeholder="ej. 137, 2697"
          onChange={handleChange}
          value={formData.cod}
        />
        <TextInput
          id="nc"
          type="text"
          placeholder="ej. 22041011, 22083030"
          text="Código N.C."
          onChange={handleChange}
          value={formData.nc}
        />
        <TextInput
          id="name"
          type="text"
          text="Nombre"
          placeholder="Nombre"
          onChange={handleChange}
          value={formData.name}
        />
        <DecimalInput
          id="capacity"
          text="Capacidad"
          placeholder="ej. 1, 0,7"
          onChange={handleChange}
          value={formData.capacity}
        />
        <DecimalInput
          id="percentage"
          text="Porcentaje Alcohólico"
          placeholder="ej. 40, 12,5"
          onChange={handleChange}
          value={formData.percentage}
        />
        <TextInput
          id="codigo_impositivo"
          type="text"
          text="Código Impositivo"
          placeholder="ej. A0, V0"
          onChange={handleChange}
          value={formData.codigo_impositivo}
        />
        <TextInput
          id="clave_product"
          type="text"
          text="Clave del Producto"
          placeholder="ej. A20, V01"
          onChange={handleChange}
          value={formData.clave_product}
        />
        <TextInput
          id="excise_product_code"
          type="text"
          text="Código Producto en II.EE."
          placeholder="ej. S200, W200"
          onChange={handleChange}
          value={formData.excise_product_code}
        />
      </div>
      <div className="flex justify-center gap-4">
        <Button
          className="px-4 py-2 bg-blue-700 text-white text-xs hover:bg-blue-900 font-bold rounded-md shadow-sm transition-colors"
          type="submit"
          onClick={handleSubmit}
        >
          CREAR
        </Button>
        <Button
          className="px-4 py-2 bg-gray-400 text-white text-xs hover:bg-gray-500 font-bold rounded-md shadow-sm transition-colors"
          type="cancel"
          onClick={cancelOnClick}
        >
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default FormLogin;
